import styled from '@emotion/styled'

export const TextFieldStyled = styled.input`
  display: inline-block;
  border-radius: 4px;
  border: none;
  height: 42px;
  width: 100%;
  min-width: 200px;
  text-indent: 5px;

  &:focus {
    outline: 0 !important;
  }

  font-size: 14px;
  font-weight: bold;
  font-family: 'Open Sans', sans-serif;
  line-height: 1.43;
  margin-right: 10px;
  border: solid 0.5px #2b3034;
`
